import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'hotels';

// PAGINATION
export const paginationHotels = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllHotels = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createHotel = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateHotel = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteHotel = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDeleted`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationHotels.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllHotels.propTypes = {
  filters: PropTypes.object.isRequired,
};

createHotel.propTypes = {
  values: PropTypes.object.isRequired,
};

updateHotel.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteHotel.propTypes = {
  id: PropTypes.string.isRequired,
};
